import CanisterModal, { CanisterFormValues } from '../../../components/location-management/CanisterModal';
import {
  AccountStorageCanister,
  AccountStorageSite,
  AccountStorageTank,
} from '../../../types/interfaces/accountStorage.interfaces';
import { createAccountStorageCanister, updateAccountStorageCanister } from '../../../api/accountStorageItemsApi';

type OnFarmCanisterModalProps = {
  mode: 'add' | 'edit';
  close: () => void;
  site: AccountStorageSite;
  tank: AccountStorageTank;
  canister?: AccountStorageCanister;
  setSelectedId?: (id: number) => void;
};

const OnFarmCanisterModal = ({ mode, close, site, tank, canister, setSelectedId }: OnFarmCanisterModalProps): JSX.Element => {
  const canisterValues = canister ? { name: canister.name, active: canister.active } : undefined;

  const createCanister = async ({ name, active }: CanisterFormValues) => {
    const { data: id } = await createAccountStorageCanister({
      name,
      active,
      accountStorageTankId: tank.accountStorageTankId,
    });
    return id;
  };

  const updateCanister = async ({ name, active }: CanisterFormValues) => {
    if (!canister) {
      return;
    }
    await updateAccountStorageCanister(canister.accountStorageCanisterId, { name, active });
  };

  return (
    <CanisterModal
      mode={mode}
      close={close}
      siteName={site.name}
      tankName={tank.name}
      canister={canisterValues}
      code={canister?.canisterCode}
      setSelectedId={setSelectedId}
      createCanister={createCanister}
      updateCanister={updateCanister}
    />
  );
};

export default OnFarmCanisterModal;
